import React from 'react';
import { cn } from '@/shared/utils/cn';
import { getPublicAssetUrl } from '@/shared/utils/publicAssetUrl';

export type CheckoutFooterProps = React.HTMLAttributes<HTMLElement>;

const publicIconUrl = (filename: string): string => {
  return getPublicAssetUrl(`icons/${filename}`);
};

const trustItems = [
  {
    icon: 'Footer_Bs.svg',
    label: "INDIA'S LARGEST\nONLINE JEWELLERY STORE",
  },
  {
    icon: 'Footer_trust.svg',
    label: 'TRUSTED BY REPUTED\nINVESTORS',
  },
  {
    icon: 'Footer-rupee.svg',
    label: 'TRANSPARENT\nPRICING',
  },
  {
    icon: 'Footer-paper.svg',
    label: '100% CERTIFIED\nJEWELLERY',
  },
];

const paymentIcons = [
  { icon: 'VISA.svg', label: 'Visa' },
  { icon: 'MasterCard.svg', label: 'Mastercard' },
  { icon: 'AMEX.svg', label: 'American Express' },
  { icon: 'Rupay.svg', label: 'RuPay' },
];

export const CheckoutFooter: React.FC<CheckoutFooterProps> = ({
  className,
  ...props
}) => {
  return (
    <footer
      className={cn(
        'mt-12 hidden w-full select-none border-t border-gray-100 bg-[#F4F4F4] py-[clamp(20px,2.4vw,32px)] md:block',
        className
      )}
      {...props}
    >
      <div className="mx-auto flex max-w-[1680px] flex-nowrap items-center justify-between gap-[clamp(16px,4vw,80px)] px-[clamp(20px,7vw,160px)]">
        <div className="flex w-[clamp(430px,52vw,920px)] flex-none flex-nowrap">
          {trustItems.map((item, index) => (
            <div
              key={item.icon}
              className={cn(
                'flex min-w-0 flex-1 flex-col items-center justify-start px-[clamp(8px,1.25vw,22px)] text-center',
                index > 0 && 'border-l border-[#DADADA]'
              )}
            >
              <div className="flex h-[clamp(34px,3.6vw,60px)] items-center justify-center">
                <img
                  src={publicIconUrl(item.icon)}
                  alt=""
                  aria-hidden="true"
                  className="max-h-[clamp(28px,3vw,54px)] max-w-[clamp(40px,4vw,68px)] opacity-70"
                />
              </div>
              <span className="mt-[clamp(6px,0.8vw,12px)] whitespace-pre-line text-[clamp(8px,0.68vw,13px)] font-semibold uppercase leading-[1.25] tracking-[0.06em] text-[#4C4C4C]">
                {item.label}
              </span>
            </div>
          ))}
        </div>

        <div className="ml-auto flex shrink-0 items-center justify-end gap-[clamp(4px,0.5vw,8px)]">
          {paymentIcons.map((item) => (
            <img
              key={item.icon}
              src={publicIconUrl(item.icon)}
              alt={item.label}
              className="h-[clamp(20px,1.8vw,32px)] w-auto"
            />
          ))}
        </div>
      </div>
    </footer>
  );
};

export default CheckoutFooter;
